/* Cook Your Mood - one copy per line.
   Shopify's add-to-cart always increments, so clicking "Get the book"
   twice leaves quantity 2 of a PDF. This normalises any line back to 1
   when the cart page loads. Runs only on the branded cart, once. */
(function () {
  var KEY = 'cymdQty1';

  function run() {
    if (!document.querySelector('.cymd-cart')) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;

        var over = cart.items.filter(function (i) { return i.quantity > 1; });

        if (!over.length) {
          try { sessionStorage.removeItem(KEY); } catch (e) {}
          return;
        }

        /* already corrected once this session and it came back over 1 -
           stop rather than reload in a loop */
        try { if (sessionStorage.getItem(KEY) === '1') return; } catch (e) {}
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}

        var chain = Promise.resolve();
        over.forEach(function (item) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: item.key, quantity: 1 })
            });
          });
        });

        return chain.then(function () { window.location.reload(); });
      })
      .catch(function () { /* leave the cart as-is rather than break it */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
